import React from "react";
import headingStyles from "./ModalHeadingStyles";

const DSETConferenceModalContent = () => (
  <div style={{ textAlign: 'left', fontFamily: 'Raleway, sans-serif' }}>
    <h3 style={headingStyles.h3}>CODAP v2 Launch & DSET Conference</h3>
    <hr />
    <div style={{ fontWeight: 'bold', color: '#000' }}>Community Building & Conference Planning</div>
    <div>9 months (2017-2018)</div>
    <p><em>Led the launch of CODAP v2 and organized the first DSET conference, convening 100+ national leaders in K–12 data science education</em></p>
    <hr />
    <div><strong style={{ fontWeight: 800 }}>Project Role:</strong> Project Manager</div>
    <div><strong style={{ fontWeight: 800 }}>Platforms:</strong> Event planning, open-source demos, community building</div>
    <div><strong style={{ fontWeight: 800 }}>Deliverables:</strong> CODAP v2 product showcase, new website, 100+ attendee conference, and launch of the DSET community</div>
    <div><strong style={{ fontWeight: 800 }}>Timeline:</strong> 9 months</div>
    <hr />

    <h4 style={headingStyles.h4}>Project Overview</h4>
    <p>
      To support the launch of CODAP v2 — a major upgrade to the open-source data analysis platform for education — I led the planning and execution of the inaugural Data Science Education Technology (DSET) conference in Berkeley. The event brought together over 100 researchers, developers, and curriculum designers to connect around the future of data science education in K–12.
    </p>
    <p>
      The goal: build community, share open tools, and catalyze the growth of data literacy in schools. Organizations represented included UMass, Michigan State University, Oceans of Data (EDC), Dataspire, Desmos, USA, Tuva, and UC Berkeley.
    </p>

    <h4 style={headingStyles.h4}>Problem Statement</h4>
    <ul>
      <li>How do we bring together diverse stakeholders in the data science education space — quickly — for a meaningful in-person event?</li>
      <li>What can we do to launch CODAP v2 while sparking momentum for the broader DSET community?</li>
    </ul>

    <h4 style={headingStyles.h4}>The Solution</h4>
    <p>
      I led the end-to-end planning for the DSET conference: sourcing speakers, creating session tracks, building demos of CODAP plugins, managing vendors, and keeping everything within NSF grant constraints. The result was a multi-day, in-person gathering of 100+ leaders from across the U.S. who are shaping the future of data science in education.
    </p>
    <p>
      The event catalyzed new collaborations, including the founding of the DS4E community and the Messy Data Coalition, where Concord is a key contributor.
    </p>

    <h4 style={headingStyles.h4}>Aligning Goals</h4>
    <p>
      This project was about more than just an event — it was about activating a community. The CODAP v2 showcase and developer workshops helped participants build and extend tools, while panel sessions helped surface emerging trends and shared values around accessibility, inquiry, and interoperability.
    </p>

    <h4 style={headingStyles.h4}>Discover</h4>
    <ul>
      <li>Scoped the needs of diverse attendees — from curriculum designers to software engineers</li>
      <li>Identified key leaders and early adopters in the data science education space</li>
      <li>Designed the conference program to balance product demos, technical talks, and strategy discussions</li>
    </ul>

    <h4 style={headingStyles.h4}>Define</h4>
    <ul>
      <li>Needed to find a venue, speakers, food, and AV support quickly — under tight NSF budget rules</li>
      <li>Planned multiple technical sessions, including live plugin demos of the new CODAP v2 architecture</li>
      <li>Worked cross-functionally to ensure research, software, and classroom voices were represented</li>
    </ul>

    <h4 style={headingStyles.h4}>Develop</h4>
    <ul>
      <li>Built a speaker lineup featuring voices from research, curriculum, and open-source tech</li>
      <li>Facilitated developer workshops for creating plugins and extensions in CODAP v2</li>
      <li>Coordinated outreach, invites, registration, signage, and post-event resources</li>
    </ul>

    <h4 style={headingStyles.h4}>Deliver</h4>
    <ul>
      <li>Hosted 100+ leaders at the first DSET conference in Berkeley, CA</li>
      <li>Launched CODAP v2 and new plugin capabilities</li>
      <li>Helped seed the DS4E network and the Messy Data Coalition</li>
      <li>Collaborated with our web developer to launch the first DSET website and online forum to support community growth (the original site is no longer live)</li>
      <li>Built long-term partnerships and made great friends — even if I don’t plan on going into conference planning full-time!</li>
    </ul>
  </div>
);

export default DSETConferenceModalContent;